if (!customElements.get('tengli-marquee')) {
  customElements.define(
    'tengli-marquee',
    class TengliMarquee extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.track = this.querySelector('[data-tengli-marquee-track]');
        this.groups = Array.from(this.querySelectorAll('[data-tengli-marquee-group]'));
        this.sequenceTemplate = this.groups[0]
          ?.querySelector('[data-tengli-marquee-sequence]')
          ?.cloneNode(true);

        if (!this.track || this.groups.length !== 2 || !this.sequenceTemplate) return;

        this.isInitialized = true;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.scheduleRebuild = this.scheduleRebuild.bind(this);
        this.handleMotionChange = this.handleMotionChange.bind(this);

        this.resizeObserver = new ResizeObserver(this.scheduleRebuild);
        this.resizeObserver.observe(this);

        if (this.motionPreference.addEventListener) {
          this.motionPreference.addEventListener('change', this.handleMotionChange);
        } else {
          this.motionPreference.addListener(this.handleMotionChange);
        }

        this.rebuild(true);

        if (document.fonts?.ready) {
          document.fonts.ready.then(() => this.scheduleRebuild(true));
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();

        if (this.motionPreference?.removeEventListener) {
          this.motionPreference.removeEventListener('change', this.handleMotionChange);
        } else {
          this.motionPreference?.removeListener(this.handleMotionChange);
        }

        cancelAnimationFrame(this.rebuildFrame);
      }

      handleMotionChange() {
        this.scheduleRebuild(true);
      }

      scheduleRebuild(force = false) {
        this.forceNextRebuild = this.forceNextRebuild || force === true;
        cancelAnimationFrame(this.rebuildFrame);
        this.rebuildFrame = requestAnimationFrame(() => {
          const shouldForce = this.forceNextRebuild;
          this.forceNextRebuild = false;
          this.rebuild(shouldForce);
        });
      }

      rebuild(force = false) {
        const viewportWidth = this.clientWidth;
        const currentSequence = this.groups[0].querySelector('[data-tengli-marquee-sequence]');
        const sequenceWidth = currentSequence?.getBoundingClientRect().width;

        if (!viewportWidth || !sequenceWidth) return;

        const copyCount = this.motionPreference.matches ? 1 : Math.max(2, Math.ceil(viewportWidth / sequenceWidth) + 1);
        const widthChanged = Math.abs((this.sequenceWidth || 0) - sequenceWidth) > 0.5;

        if (!force && !widthChanged && this.copyCount === copyCount) return;

        this.removeAttribute('data-ready');
        this.populateGroup(this.groups[0], copyCount, false);
        this.populateGroup(this.groups[1], copyCount, true);

        const firstGroupWidth = this.groups[0].getBoundingClientRect().width;
        this.style.setProperty('--tengli-marquee-distance', `${firstGroupWidth}px`);
        this.style.setProperty('--tengli-marquee-translate', `-${firstGroupWidth}px`);

        this.copyCount = copyCount;
        this.sequenceWidth = this.groups[0]
          .querySelector('[data-tengli-marquee-sequence]')
          .getBoundingClientRect().width;

        requestAnimationFrame(() => this.setAttribute('data-ready', 'true'));
      }

      populateGroup(group, copyCount, duplicateGroup) {
        const fragment = document.createDocumentFragment();

        for (let index = 0; index < copyCount; index += 1) {
          const sequence = this.sequenceTemplate.cloneNode(true);

          if (duplicateGroup || index > 0) {
            sequence.setAttribute('aria-hidden', 'true');
          } else {
            sequence.removeAttribute('aria-hidden');
          }

          fragment.append(sequence);
        }

        group.replaceChildren(fragment);
      }
    }
  );
}
